import React from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';

interface FloatingActionButtonProps {
  onPress: () => void;
  icon?: string;
  backgroundColor?: string;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  onPress,
  icon = '+',
  backgroundColor,
}) => {
  const theme = useTheme();

  return (
    <TouchableOpacity
      style={[
        styles.fab,
        { backgroundColor: backgroundColor || theme.colors.primary },
      ]}
      onPress={onPress}
      activeOpacity={0.8}
      accessibilityRole="button"
      accessible={true}
      testID="floating-action-button"
    >
      <Text style={styles.fabIcon}>{icon}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  fab: {
    position: 'absolute',
    bottom: 24,
    right: 24,
    width: 56,
    height: 56,
    borderRadius: 28,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 4,
    shadowColor: '#111c2d',
    shadowOffset: { width: 0, height: 12 },
    shadowOpacity: 0.06,
    shadowRadius: 40,
  },
  fabIcon: {
    fontFamily: 'Manrope-Bold',
    fontSize: 24,
    color: '#FFFFFF',
  },
});

export default FloatingActionButton;
